import { Button } from '@components/button/Button';
import { Theme } from '@mui/material';
import { adjustFontSize } from '@theme/styleOverrides/typography';
import { GET_APPOINTED_URL } from '@pages/Login/SignUpView/registrationContent';

export const GetAppointedLink = () => (
  <Button
    color='secondary'
    variant='text'
    href={GET_APPOINTED_URL}
    disableRipple
    sx={{
      fontSize: ({ palette }: Theme) => `${adjustFontSize(12, palette.fontSize)}px`,
      margin: 0,
      padding: 0,
      ml: '0px',
      mr: '2px',
      display: 'inline',
    }}
  >
    How do I get appointed?
  </Button>
);
